module.exports = __webpack_public_path__ + "static/img/歡迎參與300x300.9d678fd0.png";